/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetLedgerPositionsByUserIDOptions,
  GetLedgerPositionsByUserIDResponses,
} from '../types/GetLedgerPositionsByUserID'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get a specific user's positions
 * {@link /v1/ledger/positions/:user_id}
 */
export function getLedgerPositionsByUserID<ThrowOnError extends boolean = true>(
  options: Options<GetLedgerPositionsByUserIDOptions, ThrowOnError>,
): Unwrappable<RequestResult<GetLedgerPositionsByUserIDResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/ledger/positions/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetLedgerPositionsByUserIDResponses, ThrowOnError>>,
  )
}
